













import { Action } from 'vuex-class'
import { Prop, Component } from 'vue-property-decorator'
import _ from 'lodash'
import { IPatient } from '@/store/modules/views/patient/states'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'

@Component
export default class DeletePatientDialog extends VueExtendedBaseComponent {
  @Prop() private open!: boolean
  @Prop() private patient!: IPatient
  @Prop() private callback!: () => Promise<void>

  private loading = false

  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  get deletePatientDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'ลบ',
          action: this.deletePatientAction,
          loading: this.loading,
          height: '30',
        },
      },
    }
  }

  @Action('patient/deletePatient')
  private deletePatient!: (options: {}) => void

  private async deletePatientAction() {
    this.loading = true
    try {
      await this.deletePatient({
        id: this.patient._id,
      })
      this.updateSnackbar({txt: 'ลบข้อมูลผู้สูงอายุ/ผู้ป่วยสำเร็จ.', type: 'success'})
      await this.callback()
      this.loading = false
      this.closeDialog()
    } catch (e) {
      this.loading = false
    }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }
}
